<template>
    <div class="creative-card" :class="{ creative_margin: file.pack_id && file.creative_type === 'Interstitial' }">
        <div class="creative-preview">
            <video v-if="file.file_type === 'video'" class="creative_video" controls preload="none"><source :src="file.url" type="video/mp4"></video>
            <img v-else-if="file.file_type === 'html'" src="images/playable.jpg" alt="Playable" class="creative_image">
            <img v-else :src="file.url" alt="" class="creative_image">
        </div>
        <div class="creative-meta">
            <div class="creative-size-row">
                <b v-if="file.pack_id && file.creative_type === 'Interstitial'">{{ $t('companion') }}</b>
                <b v-else>{{ file.creative_type }}</b>
                <span v-if="file.width > 0 && file.height > 0" class="size-badge">{{ file.width }}×{{ file.height }}</span>
            </div>
            <div class="creative-filename">{{ file.file_name | extractFileName }}</div>
            <div v-if="file.sift_creative_id" class="creative-id">ID {{ file.sift_creative_id }}</div>
            <label class="creative-active">
                {{ $t('active') }}
                <input type="checkbox"
                       v-bind:id="file.creative_id | generateCreativeId"
                       v-bind:value="file.creative_id"
                       v-model="checkboxes.creativeStatuses">
            </label>
            <div class="creative-actions">
                <b-button v-if="!file.pack_id && creativeTypes.indexOf('Video') >= 0 && file.creative_type === 'Interstitial'" class="is-small" @click="selectVideo(file)">{{ $t('link_companion') }}</b-button>
                <b-button v-if="file.pack_id && file.creative_type === 'Interstitial'" class="is-small" @click="unlinkCompanionFromVideo(file.creative_id)">{{ $t('unlink_companion') }}</b-button>
            </div>
            <label class="creative-field">
                <span>{{ $t('language') }}</span>
                <select v-model="file.language">
                    <option v-for="language in languages"
                            :value="language.code"
                            :key="language.code">
                        {{ language.name }}
                    </option>
                </select>
            </label>
            <label class="creative-field">
                <span>{{ $t('schedule') }}</span>
                <select v-model="file.group_id" v-on:change="filterCreatives">
                    <option v-for="group in scheduleGroups"
                            :value="group.id"
                            :key="group.id">
                        {{ group.group_name }}
                    </option>
                </select>
            </label>
            <div class="creative-stats">
                <div><span>Impressions</span><b>{{ file.impressions || 0 }}</b></div>
                <div><span>CR</span><b>{{ file.installs | divideAndFormat(file.impressions, 2) }}</b></div>
                <div v-if="platformId !== 3"><span>Clicks</span><b>{{ file.clicks || 0 }}</b></div>
                <div v-if="platformId !== 3"><span>CTR</span><b>{{ file.clicks | divideAndFormat(file.impressions, 2) }}</b></div>
                <div><span>Conversions</span><b>{{ file.installs || 0 }}</b></div>
                <div v-if="platformId === 3"><span>Conv. per impression</span><b>{{ file.installs | divideAndFormat(file.clicks, 2) }}</b></div>
                <div v-else><span>Conv. per click</span><b>{{ file.installs | divideAndFormat(file.impressions, 2) }}</b></div>
            </div>
        </div>
    </div>
</template>

<style>
.left-spacer-10 {
    margin-left: 10px;
}
.bottom-spacer-20 {
    margin-bottom: 20px;
}
.inline {
    display: inline-flex;
}
.bottom-spacer-5 {
    margin-bottom: 5px;
}
.left-spacer-20 {
    margin-left: 20px;
}
.stacked {
    display: block;
}
.left-float {
    float: left;
}
.width-150 {
    min-width: 150px;
}
.overflow-auto {
    overflow: auto;
}
.transparent-background {
    background: rgba(255,255,255,0.0);
}
.table {
    width: 100%;
    border: none;
}
.right-float {
    float: right;
}
.creative-card {
    background: #fff;
    border: 1px solid #f1f1f3;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
}

.creative-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 16 / 10;
    background: #f1f1f3;
    overflow: hidden;
}

.creative-meta {
    padding: 10px 12px 12px;
    color: #363636;
}

.creative-size-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
}

.size-badge {
    background: #f1f1f3;
    border-radius: 999px;
    padding: 2px 8px;
    color: #0e0c1a;
    font-size: 0.8rem;
}

.creative-filename,
.creative-id {
    margin-top: 4px;
    color: #7c789c;
    font-size: 0.85rem;
    word-break: break-word;
}

.creative-active,
.creative-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
}

.creative-field select {
    max-width: 150px;
}

.creative-actions {
    margin-top: 8px;
}

.creative-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px 8px;
    margin-top: 10px;
    font-size: 0.8rem;
}

.creative-stats div {
    display: flex;
    justify-content: space-between;
    gap: 6px;
}

.creative-stats span {
    color: #7c789c;
}

img.creative_image {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
}
.creative_video {
    display: block;
    width: 100%;
    height: 100%;
    max-height: 100%;
    object-fit: contain;
    background: #0e0c1a;
}
.creative_margin {
    margin-left: 0;
    box-shadow: inset 4px 0 0 #ff844a;
}
</style>

<script>
   import Vue from 'vue'
   import VideoCreativeSelector from "./VideoCreativeSelector";

   export default {
       props: {
           platformId: Number,
           checkboxes: Object,
           file: Object,
           languages: Array,
           creatives: Array,
           scheduleGroups: Array,
           creativeTypes: Array,
           filterCreatives: Function
       },

       filters: {
           generateCreativeId: function (id) {
               return 'creative_' + id;
           },
           extractFileName: function (fileName) {
               const i = fileName.indexOf('|');
               if (i > 0) {
                   return fileName.substring(0, i);
               }
               else {
                   return fileName;
               }
           },
           divideAndFormat: function(dividend, divisor, decimalsToShow) {
               if (!dividend || !divisor) {
                   return 0 + ' %'
               }

               const untruncatedResult = (dividend + 0.0) / divisor;
               const untruncatedResultAsPercent = untruncatedResult * 100;

               return (Math.trunc(untruncatedResultAsPercent * Math.pow(10, decimalsToShow)) / Math.pow(10, decimalsToShow)) + ' %'
           }
       },

       methods: {
           selectVideo(creative) {
               this.$buefy.modal.open({
                   parent: this,
                   component: Vue.extend(VideoCreativeSelector),
                   hasModalCard: false,
                   trapFocus: false,
                   scroll: 'clip',
                   ariaModal: false,
                   canCancel: true,
                   width: 600,
                   props: {
                       topCreative: creative,
                       creatives: this.$props.creatives,
                       creativeType: 'Video',
                       selectFunction: this.linkCompanionToVideo
                   }
               });
           },
           linkCompanionToVideo(interstitialCreative, selectedVideoCreative) {
               let packId = null;
               for (let i = 0; i < this.$props.creatives.length; i++) {
                   if (this.$props.creatives[i].creative_id === selectedVideoCreative.creative_id) {
                       packId = this.$props.creatives[i].pack_id;
                   }
               }
               if (!packId) {
                   const d = new Date();
                   packId = (d.getTime() - 1626179268746).toString(); //The system time when this feature was first released.
               }
               for (let i = 0; i < this.$props.creatives.length; i++) {
                   if (this.$props.creatives[i].creative_id === selectedVideoCreative.creative_id || this.$props.creatives[i].creative_id === interstitialCreative.creative_id) {
                       this.$props.creatives[i].pack_id = packId;
                   }
               }
               this.$props.filterCreatives();
               this.$forceUpdate();
           },
           unlinkCompanionFromVideo(creative_id) {
               for (let i = 0; i < this.$props.creatives.length; i++) {
                   if (this.$props.creatives[i].creative_id === creative_id) {
                       this.$props.creatives[i].pack_id = null;
                   }
               }
               this.$props.filterCreatives();
               this.$forceUpdate();
           }
       }
    }
</script>